import { gql } from "@apollo/client";

export const GET_NEWS_HERO = gql`
	query News($isPreview: Boolean = false, $queryLimit: Int) {
		newsCollection(where: { OR: [{ archive: false }, { archive_exists: false }] }, preview: $isPreview, limit: $queryLimit, order: altPublishDate_DESC) {
			items {
				sys {
					id
				}
				title
				slug
				heroImage {
					url
					title
				}
			}
		}
	}
`;

export const GET_NEWS = gql`
	query News($isPreview: Boolean = false, $queryLimit: Int, $querySkip: Int) {
		newsCollection(where: { OR: [{ archive: false }, { archive_exists: false }] }, preview: $isPreview, limit: $queryLimit, skip: $querySkip, order: altPublishDate_DESC) {
			total
			items {
				sys {
					id
					publishedAt
					firstPublishedAt
				}
				archive
				title
				slug
				heroImage {
					url
					title
				}
				project {
					sys {
						id
					}
					title
				}
				altPublishDate
			}
		}
	}
`;

export const GET_NEWS_ARCHIVED = gql`
	query News($isPreview: Boolean = false, $queryLimit: Int, $querySkip: Int) {
		newsCollection(where: { archive: true }, preview: $isPreview, limit: $queryLimit, skip: $querySkip, order: altPublishDate_DESC) {
			total
			items {
				sys {
					id
					publishedAt
					firstPublishedAt
				}
				archive
				title
				slug
				heroImage {
					url
					title
				}
				project {
					sys {
						id
					}
					title
				}
				altPublishDate
			}
		}
	}
`;
